import qs from "query-string";
import { getPages } from "./pages";
import { getLinksByPageID } from "./links";
import moment from "moment";
import axios from "axios";
import SimpleReactValidator from "simple-react-validator";
import validUrl from "valid-url";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";

let jwtToken;

export function setJwtToken(token) {
  jwtToken = token;
}

export function extractParams(props) {
  const param = qs.parse(props.location.search);
  if (param) {
    return param;
  } else {
    return null;
  }
}

export async function getToken(props, setToken) {
  const localToken = localStorage.getItem("userToken");
  if (!localToken) {
    const newToken = qs.parse(props.location.search);
    if (props.location.search.length < 30) {
      console.debug("Signin, reloading...");
      props.history.push("/signin");
    } else {
      localStorage.setItem("userToken", newToken.user);
      setJwtToken(newToken.user);
      setToken(newToken.user);
      console.debug("Dashboard, reloading...");
      props.history.push("/dashboard");
    }
  } else {
    setJwtToken(localToken);
  }
}

/**
 * Encode params to send them with http
 *
 * @param {Object{any}} params
 * @returns {any}
 */
function buildParams(params) {
  return Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    )
    .join("&");
}

/**
 * Parse response
 *
 * @param {Response} response
 * @returns {Promise}
 */
function parse(response) {
  if (response.status >= 200 && response.status < 300) {
    // Successful response with json body
    const contentType = response.headers.get("Content-Type");
    if (contentType && contentType.includes("application/json")) {
      return response
        .json()
        .then((data) => Promise.resolve(data))
        .catch((e) => {
          if (e.message.includes("Unexpected end of JSON input")) {
            return Promise.resolve();
          }
          throw e;
        });
    }
    // Successful response with no json body
    return Promise.resolve();
  }
  // Error response with json body
  return response.json().then((e) => Promise.reject(e));
}

let currentAssets = "";
export function newVersion(fetch: any): Promise<boolean> {
  if (process.env.NODE_ENV === "production") {
    return new Promise(function (resolve, reject) {
      fetch("/asset-manifest.json", { cache: "no-store" })
        .then((response) => {
          if (response.ok && response.status === 200) {
            response.json().then((json) => {
              const lastAsssets = JSON.stringify(json);
              if (currentAssets === "") {
                currentAssets = lastAsssets;
                resolve(false);
              } else {
                resolve(currentAssets !== lastAsssets);
                currentAssets = lastAsssets;
              }
            });
          } else {
            resolve(false);
          }
        })
        .catch((error) => {
          resolve(false);
        });
    });
  } else {
    // console.log("Triggered check refresh");
  }
  return Promise.resolve(false);
}

function parseSpecial(response) {
  if (response.status >= 200 && response.status < 300) {
    // Successful response with json body
    const contentType = response.headers["content-type"];
    if (contentType && contentType.includes("application/json")) {
      try {
        let res = response.data;
        return res;
      } catch (e) {
        throw e;
      }

      // return (response
      //   .then((data) => Promise.resolve(data))
      //   .catch((e) => {
      //     if (e.message.includes("Unexpected end of JSON input")) {
      //       return Promise.resolve();
      //     }
      //     throw e;
      //   });
      // )
    }
    // Successful response with no json body
    return Promise.resolve();
  }
  // Error response with json body
  return response.then((e) => Promise.reject(e));
}

/**
 * Perform a fetch on the API.
 *
 * @param {string} endpoint - Endpoint to fetch.
 * @param {Object{
 *  jwt?: string
 *  params?: ApiParams
 *  method?: {Enum: GET, POST, DELETE, PUT}
 * }} options
 * @returns {Promise<Response>}
 */
export function fetchApi(endpoint, { params, method = "GET" } = {}) {
  // build URL
  const fullURL =
    API_URL +
    endpoint +
    (method === "GET" && params ? `?${buildParams(params)}` : "");
  // build headers
  const headers = {
    "Content-Type": "application/json",
  };
  if (jwtToken) {
    headers.Authorization = `Bearer ${jwtToken}`;
  }
  return fetch(fullURL, {
    method,
    headers,
    body: method !== "GET" && params ? JSON.stringify(params) : undefined,
  }).then(parse);
}

export const fetchPages = async (
  setListPages,
  setPages,
  setLinks,
  pageID,
  history,
  pageDeleted,
  account
) => {
  const pagesAdded = await getPages();
  if (pagesAdded.length > 0) {
    await setListPages(pagesAdded);
    if (pageID) {
      let indexNewPage = pagesAdded.findIndex((p) => p.PageID === +pageID);
      await setPages(pagesAdded[indexNewPage]);
      const links = await getLinksByPageID(pagesAdded[indexNewPage].PageID);
      await setLinks(links);
      if (pageDeleted) {
        window.location.replace("/links?status=pageDeleted");
      }
    } else {
      await setPages(pagesAdded[0]);
      const links = await getLinksByPageID(pagesAdded[0].PageID);
      await setLinks(links);
      if (pageDeleted) {
        window.location.replace("/links?status=pageDeleted");
      }
    }
  } else {
    await setListPages([]);
    await setLinks([]);
    if (pageDeleted) {
      history.push("/new-page?status=pageDeleted");
    } else if (!account.HasCompletedOnboarding) {
      history.push("/welcome");
    } else {
      history.push("/new-page");
    }
  }
};

export const refreshContextProviderPagesOnly = async (
  setListPages,
  setPages,
  pageID
) => {
  const pagesAdded = await getPages();
  if (pagesAdded.length > 0) {
    await setListPages(pagesAdded);
    if (pageID) {
      let indexNewPage = pagesAdded.findIndex((p) => p.PageID === +pageID);
      await setPages(pagesAdded[indexNewPage]);
    } else {
      await setPages(pagesAdded[0]);
    }
  }
};

export const isStatusAllowedToPush = (isScheduled, startDate, endDate) => {
  if (isScheduled) {
    if (startDate && endDate) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
};

export const getEndDateAndInterval = (date) => {
  let res = {};
  switch (date) {
    case "0":
      res.endDate = moment().subtract("7", "days").format("YYYY-MM-DD");
      res.interval = "day";
      return res;

    case "1":
      res.endDate = moment().subtract("28", "days").format("YYYY-MM-DD");
      res.interval = "day";
      return res;

    case "2":
      res.endDate = moment().subtract("2", "months").format("YYYY-MM-DD");
      res.interval = "week";
      return res;

    case "6":
      res.endDate = moment().subtract("6", "months").format("YYYY-MM-DD");
      res.interval = "month";
      return res;

    default:
      res.endDate = moment().subtract("7", "days").format("YYYY-MM-DD");
      res.interval = "day";
  }
};

export async function fetchApiFile(endpoint, { params, method = "GET" } = {}) {
  // build URL
  const fullURL =
    API_URL +
    endpoint +
    (method === "GET" && params ? `?${buildParams(params)}` : "");
  // build headers
  const headers = {
    "content-type": "multipart/form-data",
  };
  if (jwtToken) {
    headers.Authorization = `Bearer ${jwtToken}`;
  }

  let res = await axios({
    method,
    url: fullURL,
    headers,
    data: method !== "GET" && params ? params : undefined,
  });
  let imageUrl = await parseSpecial(res);
  return imageUrl;

  // return axios({
  //   method,
  //   url: fullURL,
  //   headers,
  //   data: method !== "GET" && params ? params : undefined,
  // }).then(parse);
}

export const validateSocialLinks = (social) => {
  let validator = new SimpleReactValidator();
  if (social.url.length === 0) {
    let res = {
      valid: false,
      error: `Veuillez renseigner votre profil ${social.type} ou décocher la case.`,
    };
    return res;
  } else if (
    (social.type === "youtube" && social.url.indexOf("youtube.com") === -1) ||
    (social.type === "youtube" && !social.url.indexOf("youtu.be") === -1)
  ) {
    let res = {
      valid: false,
      error: `Votre URL Youtube semble incorrecte. Veuillez rentrer une URL valide.`,
    };
    return res;
  } else if (
    social.type === "facebook" &&
    !social.url.includes("facebook.com")
  ) {
    let res = {
      valid: false,
      error: `Votre URL Facebook semble incorrecte. Veuillez rentrer une URL valide.`,
    };
    return res;
  } else if (social.type === "instagram") {
    if (social.url.includes(".")) {
      let instaUrl = social.url.replace(".", "");
      validator.message("socialUsername", instaUrl, "alpha_num_dash");
      if (validator.fieldValid("socialUsername")) {
        let res = {
          valid: true,
        };
        return res;
      } else {
        let res = {
          valid: false,
          error: `Le champ ${social.type} peut seulement contenir des chiffres, lettres, tirets et points.`,
        };
        return res;
      }
    } else {
      validator.message("socialUsername", social.url, "alpha_num_dash");
      if (validator.fieldValid("socialUsername")) {
        let res = {
          valid: true,
        };
        return res;
      } else {
        let res = {
          valid: false,
          error: `Le champ ${social.type} peut seulement contenir des chiffres, lettres, tirets et points.`,
        };
        return res;
      }
    }
  } else if (
    social.type !== "facebook" &&
    social.type !== "youtube" &&
    social.type !== "instagram" &&
    social.type !== "linkedin"
  ) {
    validator.message("socialUsername", social.url, "alpha_num_dash");
    if (validator.fieldValid("socialUsername")) {
      let res = {
        valid: true,
      };
      return res;
    } else {
      let res = {
        valid: false,
        error: `Le champ ${social.type} peut seulement contenir des chiffres, lettres et tirets.`,
      };
      return res;
    }
  } else {
    if (validUrl.isUri(social.url)) {
      let res = {
        valid: true,
      };
      return res;
    } else {
      let res = {
        valid: false,
        error: `Le champ ${social.type} ne contient pas une URL valide.`,
      };
      return res;
    }
  }
};

export const validateWidth = (code) => {
  let width;
  let isValid;
  if (code.includes("width")) {
    width = code.split("width:")[1];
    width = width.split("px")[0];
    width = +width;
    if (width > 350) {
      isValid = false;
    } else {
      isValid = true;
    }
    return isValid;
  }
};

export const validateWidthDeezer = (code) => {
  let width;
  let isValid;
  if (code.includes("width")) {
    width = code.split('width="')[1];
    width = width.split('"')[0];
    width = +width;
    if (width > 360) {
      isValid = false;
    } else {
      isValid = true;
    }
    return isValid;
  }
};

export const defineCustomerPlanID = (plan, cycle) => {
  let pricing;
  if (cycle === "yearly" && plan === "premium") {
    pricing = "price_1I05WgGa6jhml1bV3HREFlAE";
  } else if (cycle === "yearly" && plan === "agency") {
    pricing = "price_1HtFg0Ga6jhml1bVab9vDy2H";
  } else if (cycle === "monthly" && plan === "premium") {
    pricing = "price_1I05WgGa6jhml1bVTDJqkQZF";
  } else {
    pricing = "price_1HtFg0Ga6jhml1bVwW0yab8b";
  }
  return pricing;
};

export const getCurrentPlan = (pricingID) => {
  switch (pricingID) {
    case "price_1HtFg0Ga6jhml1bVab9vDy2H":
      return "Agence annuel";
    case "price_1HtFg0Ga6jhml1bVwW0yab8b":
      return "Agence mensuel";
    case "price_1I05WgGa6jhml1bV3HREFlAE":
      return "Premium annuel";
    case "price_1I05WgGa6jhml1bVTDJqkQZF":
      return "Premium mensuel";
    default:
      return "Custom";
  }
};

export const getPercentUsage = (nbPages, limitations) => {
  let percent = (nbPages / limitations) * 100;
  return percent;
};

export const isUsingURLShortener = (link) => {
  link = link.toLowerCase();
  if (link.includes("bit.ly/")) {
    return true;
  } else if (link.includes("is.gd/")) {
    return true;
  } else if (link.includes("rb.gy/")) {
    return true;
  } else if (link.includes("tinyurl.com/")) {
    return true;
  } else if (link.includes("cutt.ly/")) {
    return true;
  } else if (link.includes("ow.ly/")) {
    return true;
  } else {
    return false;
  }
};

export const isUsingUTMs = (link) => {
  link = link.toLowerCase();
  if (link.includes("?")) {
    link = link.split("?")[1];
    if (link.includes("utm_source")) {
      return true;
    } else if (link.includes("utm_campaign")) {
      return true;
    } else if (link.includes("utm_medium")) {
      return true;
    } else if (link.includes("utm_term")) {
      return true;
    } else if (link.includes("utm_content")) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const validateLinkContent = async (link, isPaying) => {
  if (isPaying) {
    return true;
  } else {
    let usesUTMs = await isUsingUTMs(link);
    let usesURLShortener = await isUsingURLShortener(link);

    if (usesUTMs) {
      let res = {
        err: "Veuillez passer en premium pour utiliser les UTMs",
      };
      return res;
    } else if (usesURLShortener) {
      let res = {
        err: "Veuillez passer en premium pour utiliser un URL shortener",
      };
      return res;
    } else {
      return true;
    }
  }
};
